import React from 'react';

import Found from '../../assets/img/404.svg'

const NotFound = () =>

    <>
        <div
            className="page-header section-dark"
            style={{
                backgroundImage:
                    "url(" + require("../../assets/img/background-OIP.jpg") + ")",
            }} />

        <style>
            {".page-header {height: 80px; min-height: unset}"}
        </style>

        <div className="NotFound">

            <img className="Error-404" src={Found} alt="Error404" />

            <div className="Text-Error" >
                <h1>No se ha encontrado esta página</h1>
                <p>Lo sentimos esta página no existe.</p>
            </div>
        </div>
    </>
export default NotFound;